<template>
  <div class="divPageParent">
    <!--导航 -->
    <!-- <nav-bar></nav-bar> -->
    <!--背景图及视频展示 -->
    <DetailsNav></DetailsNav>
    <head-first-widget
      :logoImg="baseData.detailLogoImage.url"
      :name="baseData.name"
      :description="baseData.description"
      :lastUpdate="baseData.lastUpdate"
      :type="baseData.trade.name"
      :numItems="numItems"
      :pVideoUrl="baseData.pVideoUrl"
      :industryLogoUrl="industryLogoUrl"
      :linkData="linkData"
    ></head-first-widget>
    <!--用户前后台演示 -->
    <user-display-widge
      :displayData="displayData"
      :linkData="linkData"
      type="python"
      hoverColor="python"
      btnInitColor="#496BCC"
      btnHoverColor="#2849A7"
      :lastUpdate="baseData.lastUpdate"
    ></user-display-widge>
    <div style="position:relative;">
      <flow-widget
        :flowData="flowData"
        :baseHeight="baseHeight"
        :localItemIndex="localItemIndex"
        class="web_scroll"
      ></flow-widget>
    </div>
    <div class="divOffsetParent">
      <project-advantage-widge
        :img="projectAdvantageImg"
        :desc="projectAdvantageDesc"
        :bg="projectAdvantageBg"
        style="padding-top:40px;"
      >
        <title-widge
          :title="projectAdvantageTitle"
          :desc="projectAdvantageSubTitle"
        ></title-widge>
      </project-advantage-widge>
      <target-learner-widge :details="targetDetails">
        <title-widge :title="targetTitle" :desc="targetDesc"></title-widge>
      </target-learner-widge>
      <frame-work-widge
        :data="functionFrameWorkWidgeData"
        style="padding-bottom:0"
      >
        <title-widge
          :title="functionTitle"
          :desc="functionSubTitle"
        ></title-widge>
      </frame-work-widge>
      <frame-work-widge :data="technologyFrameWorkWidgeData">
        <title-widge
          :title="technologyTitle"
          :desc="technologySubTitle"
        ></title-widge>
      </frame-work-widge>
      <solve-plan-widge :bg="solveBgUrl">
        <title-widge
          :title="solverTitle"
          :desc="solveDesc"
          titleColor="white"
          descColor="white"
          class="solvePlayTitle"
        ></title-widge>
      </solve-plan-widge>
      <study-path-widge
        :title="studyTitle"
        :desc="studyDesc"
        :bgUrl="studyBgUrl"
        :courseData="courseOutData"
        style="padding-bottom: 0px"
      ></study-path-widge>
      <techer-display-widge
        :title="teacherTitle"
        :desc="teacherDesc"
        :imgUrls="teacherUrls"
      ></techer-display-widge>
    </div>
    <bottom-widge></bottom-widge>
  </div>
</template>
<script>
// import navBar from "./../../../components/navBar";
import DetailsNav from "./../../../components/detailsNav.vue";
import { Content } from "../../../../gqlapi/ContentDetail.js";
import headFirstWidget from "./components/headFirstWidget";
import UserDisplayWidge from "./../common/components/userDisplayWidge";
import flowWidget from "./../common/components/flowWidget";
import projectAdvantageWidge from "./../common/components/projectAdvantageWidge";
import targetLearnerWidge from "./../common/components/targetLearnerWidge";
import frameWorkWidge from "./../common/components/frameWorkWidge";
import solvePlanWidge from "./../common/components/solvePlanWidge";
import studyPathWidge from "./components/studyPathWidge";
import techerDisplayWidge from "./components/techerDisplayWidge";
import bottomWidge from "./../../../components/bottomWidge";
import titleWidge from "./components/titleWidge";
import { elTabsAddEventListener,pushArr } from "./../../../js/tools";
export default {
  components: {
    // navBar,
    DetailsNav,
    headFirstWidget,
    UserDisplayWidge,
    flowWidget,
    projectAdvantageWidge,
    targetLearnerWidge,
    frameWorkWidge,
    solvePlanWidge,
    studyPathWidge,
    techerDisplayWidge,
    bottomWidge,
    titleWidge,
  },
  data() {
    return {
      baseData: {
        detailLogoImage: {
          url: "",
        },
        trade: {},
        functionalArchitectureDiagram: {
          url: "",
        },
        technicalArchitectureDiagram: {
          url: "",
        },
      },
      numItems:[],
      industryLogoUrl: "",
      displayData: [],
      linkData: [],
      flowData: [],
      baseHeight: 1381,
      localItemIndex: 0,
      projectAdvantageTitle: "",
      projectAdvantageSubTitle: "",
      projectAdvantageImg: "",
      projectAdvantageDesc: [],
      projectAdvantageBg: "",
      targetTitle: "",
      targetDesc: "",
      targetDetails: [],
      functionFrameWorkWidgeData: {},
      functionTitle: "",
      functionSubTitle: "",
      technologyFrameWorkWidgeData: {},
      technologyTitle: "",
      technologySubTitle: "",
      solveBgUrl: "",
      solverTitle: "",
      solveDesc: "",
      studyTitle: "",
      studyDesc: "",
      studyBgUrl: "",
      teacherTitle: "",
      teacherDesc: "",
      courseOutData: [],
      teacherUrls: [],
      oldHeight: 0,
      scrollClass: {
        pInit: "parent web_scroll",
        pChange: "parent web_scroll  p-change",
        cInit: "ul-init",
        cChange: "",
      },
      scrollFlag: {
        top: true,
        bottom: true,
      },
    };
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let scrollEleParent = document.querySelector(".web_scroll");
    let scrollEleUl = scrollEleParent.children[0];
    this.scrollEleParent = scrollEleParent;
    this.scrollEleUl = scrollEleUl;
    Object.freeze(this.scrollFlag);
    Object.freeze(this.scrollClass);
    Object.freeze(this.oldHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getDisplayData() {
      let data = this.baseData;
      let arr = [];
      for (let item of data.coverImageGroupList) {
        let imgs = [];
        item.imageAndLink.forEach((v) => {
          if (v.image) {
            imgs.push(v.image.url);
          }
        });
        arr.push({
          desc: item.groupName,
          type: item.imageType,
          imgs: imgs,
        });
      }
      this.displayData = arr;
      this.linkData = data.demoTitleLinkGroup;
    },
    handleScroll() {
      let oldHeight = this.oldHeight;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollHeight = this.baseHeight;
      let eles = document.querySelector(".divOffsetParent").children;
      for (let index in eles) {
        if (localHeight > eles[index].offsetTop + scrollHeight - 10) {
          this.localItemIndex = Number(index);
        }
      }
      let scrollFlag = this.scrollFlag;
      let scrollClass = this.scrollClass;
      if (oldHeight > localHeight) {
        //向上
        if (scrollFlag.top && localHeight < scrollHeight) {
          scrollFlag.top = false;
          scrollFlag.bottom = true;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pInit;
          child.className = scrollClass.cInit;
        }
      } else {
        //向下
        if (scrollFlag.bottom && localHeight > scrollHeight) {
          scrollFlag.top = true;
          scrollFlag.bottom = false;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pChange;
          child.className = scrollClass.cChange;
        }
      }
      this.oldHeight = localHeight;
    },
    getData() {
      this.$axios.post('/api',{
            operationName: "Content",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: Content
        })
        .then((res) => {
          this.baseData = res.data.data.pContent;
          this.getHeadFirstWidgeData();
          this.getDisplayData();
          this.getCourseData();
          this.getFlowData();
          this.getFrameWorkWidgeData();
          this.getTeacherData();
          // this.getBaseHeight()
          this.getSolvePlanData();
          this.getTargetLearnerData();
          this.getProjectAdvantageData();
        });
    },
    getProjectAdvantageData() {
      let data = this.baseData.detailsList[0];
      this.projectAdvantageTitle = data.title;
      this.projectAdvantageSubTitle = data.subTitle;
      this.projectAdvantageSubTitle = data.subTitle;
      let tuWen = data.tuWen;
      if (!tuWen) {
        return;
      }
      let description = tuWen.description;
      if (!description) {
        return;
      }
      this.projectAdvantageDesc = description
        .split("。")
        .filter((item) => item && item.trim());
      this.projectAdvantageImg = tuWen.image
        ? tuWen.image.url
        : tuWen.bgImage
        ? tuWen.bgImage.url
        : "";
      this.projectAdvantageBg = tuWen.textBgImage ? tuWen.textBgImage.url : "";
    },
    getTargetLearnerData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[1];
      if (!data) {
        return;
      }
      this.targetTitle = data.title;
      this.targetDesc = data.subTitle;
      this.targetDetails = data.lieBiao;
    },
    getSolvePlanData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[4];
      if (!data) {
        return;
      }
      let tuWen = data.tuWen ? data.tuWen : {};
      this.solveBgUrl = tuWen.image ? tuWen.image.url : "";
      this.solverTitle = data.title;
      this.solveDesc = data.subTitle;
    },
    getHeadFirstWidgeData() {
      let baseData = this.baseData;
      this.industryLogoUrl = baseData.trade
        ? baseData.trade.iconFile
          ? baseData.trade.iconFile.url
          : ""
        : "";
      let numItems = [];
      pushArr(baseData.baseInfoTitle1, numItems);
      pushArr(baseData.baseInfoTitle2, numItems);
      pushArr(baseData.baseInfoTitle3, numItems);
      pushArr(baseData.baseInfoTitle4, numItems);
      pushArr(baseData.baseInfoTitle5, numItems);
      pushArr(baseData.baseInfoTitle6, numItems);
      this.numItems = numItems;
    },
    getTeacherData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[6];
      if (!data) {
        return;
      }
      this.teacherTitle = data.title;
      this.teacherDesc = data.subTitle;
      let teacherUrls = [];
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      for (let item of lieBiao) {
        teacherUrls.push({
          name: item.title,
          quarters: item.subTitle,
          headerImage: item.image,
          details: item.description,
        });
      }
      this.teacherUrls = teacherUrls;
    },
    getFrameWorkWidgeData() {
      let baseData = this.baseData;
      let functionFrameWorkWidgeData = baseData.detailsList[2];
      this.functionFrameWorkWidgeData = functionFrameWorkWidgeData;
      this.functionTitle = functionFrameWorkWidgeData.title;
      this.functionSubTitle = functionFrameWorkWidgeData.subTitle;
      let technologyFrameWorkWidgeData = baseData.detailsList[3];
      this.technologyFrameWorkWidgeData = technologyFrameWorkWidgeData;
      this.technologyTitle = technologyFrameWorkWidgeData.title;
      this.technologySubTitle = technologyFrameWorkWidgeData.subTitle;
    },

    //获取流程管理的数据
    getFlowData() {
      let detailsList = this.baseData.detailsList;
      let arr = [];
      detailsList.forEach((item, index) => {
        arr.push({
          index: index,
          desc: item.navTitle,
        });
      });
      this.flowData = arr;
    },
    infoData(title, desc, name) {
      let items = [];
      let obj = {};
      for (let f = 0; f < title.length; f++) {
        for (let d = 0; d < desc.length; d++) {
          if (f === d) {
            if (title[f] !== null && title[f] !== "") {
              if (name === "base") {
                let baseInfo = desc[d];
                if (desc[d] !== null && desc[d] !== "") {
                  baseInfo = desc[d].split("\n");
                } else {
                  baseInfo = desc[d];
                }
                obj = {
                  title: title[f],
                  desc: baseInfo,
                };
              } else {
                let videoName = title[f].lastIndexOf("[");
                let videoUrl = title[f].lastIndexOf("(");

                let names = "";
                let urls = "";
                if (videoName > 0) {
                  names = title[f].substring(
                    title[f].indexOf("[") + 1,
                    title[f].indexOf("]")
                  );
                }
                if (videoUrl > 0) {
                  urls = title[f].substring(
                    title[f].indexOf("(") + 1,
                    title[f].indexOf(")")
                  );
                }
                let videoObj = {};
                videoObj = {
                  name: names,
                  url: urls,
                };
                obj = {
                  title: title[f],
                  desc: desc[d],
                  video: videoObj,
                };
              }
              items.push(obj);
            }
          }
        }
      }
      let arr = [];
      items.forEach(function(item) {
        if (item.desc !== null && item.desc !== "") {
          var items = item.desc.split(/;|；/);
          var descData = items.map((val) => {
            var arr = val.split("：");
            return { title: arr[0], content: arr[1] };
          });
          let couseOutBase = {
            titles: item.title.replace(/\[.*?\]/g, "").replace(/\(.*?\)/g, ""),
            desc: descData,
            video: item.video,
          };
          arr.push(couseOutBase);
        }
      });
      this.courseOutData = arr;
      setTimeout(function() {
        elTabsAddEventListener(document, arr.length);
      }, 1000);
    },
    getCourseData() {
      let pContent = this.baseData;
      let courseOutlineTitle = [
        pContent.courseOutlineTitle1,
        pContent.courseOutlineTitle2,
        pContent.courseOutlineTitle3,
        pContent.courseOutlineTitle4,
        pContent.courseOutlineTitle5,
        pContent.courseOutlineTitle6,
        pContent.courseOutlineTitle7,
        pContent.courseOutlineTitle8,
        pContent.courseOutlineTitle9,
        pContent.courseOutlineTitle10,
        pContent.courseOutlineTitle11,
        pContent.courseOutlineTitle12,
        pContent.courseOutlineTitle13,
        pContent.courseOutlineTitle14,
        pContent.courseOutlineTitle15,
        pContent.courseOutlineTitle16,
        pContent.courseOutlineTitle17,
        pContent.courseOutlineTitle18,
        pContent.courseOutlineTitle19,
        pContent.courseOutlineTitle20,
      ];
      let courseOutlineDesc = [
        pContent.courseOutlineDesc1,
        pContent.courseOutlineDesc2,
        pContent.courseOutlineDesc3,
        pContent.courseOutlineDesc4,
        pContent.courseOutlineDesc5,
        pContent.courseOutlineDesc6,
        pContent.courseOutlineDesc7,
        pContent.courseOutlineDesc8,
        pContent.courseOutlineDesc9,
        pContent.courseOutlineDesc10,
        pContent.courseOutlineDesc11,
        pContent.courseOutlineDesc12,
        pContent.courseOutlineDesc13,
        pContent.courseOutlineDesc14,
        pContent.courseOutlineDesc15,
        pContent.courseOutlineDesc16,
        pContent.courseOutlineDesc17,
        pContent.courseOutlineDesc18,
        pContent.courseOutlineDesc19,
        pContent.courseOutlineDesc20,
      ];
      this.infoData(courseOutlineTitle, courseOutlineDesc, "out");
      let studyPathData = pContent.detailsList[5]
        ? pContent.detailsList[5]
        : {};
      this.studyTitle = studyPathData.title;
      this.studyDesc = studyPathData.subTitle;
      this.studyBgUrl = studyPathData.tuWen
        ? studyPathData.tuWen.image
          ? studyPathData.tuWen.image.url
          : ""
        : "";
    },
  },
};
</script>
<style>
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg img{
  width: auto;
  height: 220px;
}
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg .divDesc{
  height: 220px;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
.divOffsetParent {
  position: relative;
  overflow: hidden;
  top: -38px;
}
.divPageParent {
  min-width: 1290px;
  background-color: white;
}
</style>
<style lang="scss">
.divPageParent {
  .divUserDisplay {
    .el-tabs__item.is-active {
      color: rgba(73, 107, 204, 1) !important;
      border-bottom: 5px solid rgba(73, 107, 204, 1);
    }
  }
}
</style>
